/**
 * Created by alex.y on 10/3/2017.
 */
export enum OrderDataType{
    Comment,
    File,
    CPB3461 = 2,
    CPB7501 = 3
}


// WEBPACK FOOTER //
// ./app/objects/orders/orderDataType.ts